import { ThemeConfigType } from './typing';
const colorBgContainer = '#F8F8F8'; // Light background
const colorBgLayout = '#FFFFFF'; // Light layout background

const themeId = 'light-protanopia-and-deuteranopia';

export const lightProtAndDeuterTheme: ThemeConfigType = {
  id: themeId,
  type: 'light',
  name: `themes.${themeId}`,
  previewImage: 'https://github.githubassets.com/assets/light_colorblind_preview-7cc1768c24cd.svg',
  previewImageDisc: 'https://github.githubassets.com/assets/light_colorblind_disc-307fec254fd3.svg',
  theme: {
    algorithm: [],
    token: {
      blue: '#5B9BD5', // Adjusted blue
      purple: '#A5A5A5', // Adjusted greyish purple
      cyan: '#00B0F0', // Adjusted cyan
      green: '#70AD47', // Adjusted green
      magenta: '#E36C09', // Adjusted magenta for better visibility
      pink: '#FFC0CB', // Light pink
      red: '#FF0000', // Bright red
      orange: '#FFA500', // Bright orange
      yellow: '#FFFF00', // Bright yellow
      volcano: '#D35400', // Adjusted volcano
      geekblue: '#4F81BD', // Adjusted blue
      gold: '#FFD700', // Bright gold
      lime: '#92D050', // Adjusted lime
      colorPrimary: '#5B9BD5', // Adjusted blue
      colorSuccess: '#70AD47', // Adjusted green
      colorWarning: '#FFD700', // Bright gold
      colorError: '#FF0000', // Bright red
      colorInfo: '#00B0F0', // Adjusted cyan
      colorLink: '#5B9BD5', // Adjusted blue
      colorTextBase: '#000000', // Black text for high contrast
      colorBgBase: '#FFFFFF', // White background
      lineWidth: 1,
      lineType: 'solid',
      borderRadius: 6,
      colorText: '#333333', // Dark grey text
      colorTextSecondary: '#666666', // Lighter grey text
      colorTextTertiary: '#999999', // Even lighter grey text
      colorTextQuaternary: '#CCCCCC', // Lightest grey text
      colorFill: '#E6E6E6', // Light grey fill
      colorFillSecondary: '#CCCCCC', // Lighter grey fill
      colorFillTertiary: '#B3B3B3', // Even lighter grey fill
      colorFillQuaternary: '#999999', // Lightest grey fill
      colorBgLayout: colorBgLayout,
      colorBgContainer: colorBgContainer,
      colorBgElevated: '#FFFFFF', // White for elevated backgrounds
      colorBgSpotlight: '#FFD700', // Gold for spotlight
      colorBgBlur: 'transparent',
      colorBorder: '#CCCCCC', // Light grey border
      colorBorderSecondary: '#B3B3B3', // Lighter grey border
      // colorPrimaryBg: '#D9EAF7', // Light blue background
      // colorPrimaryBgHover: '#B3D4EF', // Darker light blue hover
      // colorPrimaryBorder: '#5B9BD5', // Adjusted blue border
      // colorPrimaryBorderHover: '#4F81BD', // Darker blue border hover
      // colorPrimaryHover: '#4F81BD', // Darker blue hover
      // colorPrimaryActive: '#3B5998', // Darkest blue active
      // colorPrimaryTextHover: '#4F81BD', // Darker blue text hover
      // colorPrimaryText: '#5B9BD5', // Adjusted blue text
      // colorPrimaryTextActive: '#3B5998', // Darkest blue text active
      colorSuccessBg: '#E2F0D9', // Light green background
      colorSuccessBgHover: '#C5E0B3', // Darker light green hover
      colorSuccessBorder: '#70AD47', // Adjusted green border
      colorSuccessBorderHover: '#548235', // Darker green border hover
      colorSuccessHover: '#548235', // Darker green hover
      colorSuccessActive: '#385723', // Darkest green active
      colorSuccessTextHover: '#548235', // Darker green text hover
      colorSuccessText: '#70AD47', // Adjusted green text
      colorSuccessTextActive: '#385723', // Darkest green text active
      colorErrorBg: '#F8D7DA', // Light red background
      colorErrorBgHover: '#F1AEB5', // Darker light red hover
      colorErrorBgActive: '#F28B90', // Darkest light red active
      colorErrorBorder: '#FF0000', // Bright red border
      colorErrorBorderHover: '#E60000', // Darker red border hover
      colorErrorHover: '#E60000', // Darker red hover
      colorErrorActive: '#CC0000', // Darkest red active
      colorErrorTextHover: '#E60000', // Darker red text hover
      colorErrorText: '#FF0000', // Bright red text
      colorErrorTextActive: '#CC0000', // Darkest red text active
      colorWarningBg: '#FFF4CC', // Light gold background
      colorWarningBgHover: '#FFE599', // Darker light gold hover
      colorWarningBorder: '#FFD700', // Bright gold border
      colorWarningBorderHover: '#E6C300', // Darker gold border hover
      colorWarningHover: '#E6C300', // Darker gold hover
      colorWarningActive: '#B38F00', // Darkest gold active
      colorWarningTextHover: '#E6C300', // Darker gold text hover
      colorWarningText: '#FFD700', // Bright gold text
      colorWarningTextActive: '#B38F00', // Darkest gold text active
      colorInfoBg: '#D9EAF7', // Light blue background
      colorInfoBgHover: '#B3D4EF', // Darker light blue hover
      colorInfoBorder: '#5B9BD5', // Adjusted blue border
      colorInfoBorderHover: '#4F81BD', // Darker blue border hover
      colorInfoHover: '#4F81BD', // Darker blue hover
      colorInfoActive: '#3B5998', // Darkest blue active
      colorInfoTextHover: '#4F81BD', // Darker blue text hover
      colorInfoText: '#5B9BD5', // Adjusted blue text
      colorInfoTextActive: '#3B5998', // Darkest blue text active
      colorLinkHover: '#4F81BD', // Darker blue hover
      colorLinkActive: '#3B5998', // Darkest blue active
      colorBgMask: '#FFFFFFB3', // Semi-transparent white mask
      colorWhite: '#FFFFFF', // White
      lineWidthBold: 2,
      colorFillContent: '#E6E6E6', // Light grey fill content
      colorFillContentHover: '#CCCCCC', // Lighter grey fill content hover
      colorFillAlter: '#B3B3B3', // Even lighter grey fill alter
      colorBgContainerDisabled: '#F0F0F0', // Light grey disabled background
      colorBorderBg: '#CCCCCC', // Light grey border background
      colorSplit: '#999999', // Lighter grey split
      colorTextPlaceholder: '#999999', // Lighter grey placeholder text
      colorTextDisabled: '#CCCCCC', // Lightest grey disabled text
      colorTextHeading: '#333333', // Dark grey heading text
      colorTextLabel: '#666666', // Lighter grey label text
      colorTextDescription: '#999999', // Even lighter grey description text
      colorTextLightSolid: '#FFFFFF', // White solid text
      colorHighlight: '#FFD700', // Bright gold highlight
      colorBgTextHover: '#E6E6E6', // Light grey text hover background
      colorBgTextActive: '#CCCCCC', // Lighter grey text active background
      colorIcon: '#666666', // Lighter grey icon
      colorIconHover: '#333333', // Dark grey icon hover
      colorErrorOutline: '#E60000', // Darker red outline
      colorWarningOutline: '#E6C300', // Darker gold outline
      controlItemBgHover: '#F0F0F0', // Light grey item hover background
      controlItemBgActive: '#E6E6E6', // Light grey item active background
      controlItemBgActiveHover: '#CCCCCC', // Lighter grey item active hover background
      controlItemBgActiveDisabled: '#F0F0F0', // Light grey item active disabled background
      controlTmpOutline: '#B3B3B3', // Even lighter grey tmp outline
      controlOutline: '#999999', // Lighter grey outline
      linkDecoration: 'none',
      linkHoverDecoration: 'none',
      linkFocusDecoration: 'none',
      boxShadow:
        '\n      0 6px 16px 0 #999999,\n      0 3px 6px -4px #999999,\n      0 9px 28px 8px #999999\n    ',
      boxShadowSecondary:
        '\n      0 6px 16px 0 #999999,\n      0 3px 6px -4px #999999,\n      0 9px 28px 8px #999999\n    ',
      boxShadowTertiary:
        '\n      0 1px 2px 0 #999999,\n      0 1px 6px -1px #999999,\n      0 2px 4px 0 #999999\n    ',
    },
  },
  layout: {
    hashId: themeId,
    colorPrimary: '#5B9BD5', // Adjusted blue
    colorTextAppListIcon: '#666666', // Lighter grey icon text
    colorBgAppListIconHover: '#E6E6E6', // Light grey icon hover background
    colorTextAppListIconHover: '#333333', // Dark grey icon hover text
    bgLayout: `linear-gradient(${colorBgContainer}, ${colorBgLayout} 28%)`,
    sider: {
      paddingInlineLayoutMenu: 8,
      paddingBlockLayoutMenu: 0,
      colorBgCollapsedButton: '#FFFFFF', // White collapsed button
      colorTextCollapsedButtonHover: '#333333', // Dark grey collapsed button hover text
      colorTextCollapsedButton: '#666666', // Lighter grey collapsed button text
      colorMenuBackground: 'transparent',
      colorMenuItemDivider: '#E6E6E6', // Light grey menu item divider
      colorBgMenuItemHover: '#F0F0F0', // Light grey menu item hover background
      colorBgMenuItemSelected: '#E6E6E6', // Light grey menu item selected background
      colorTextMenuItemHover: '#333333', // Dark grey menu item hover text
      colorTextMenuSelected: '#333333', // Dark grey menu item selected text
      colorTextMenuActive: '#333333', // Dark grey menu item active text
      colorTextMenu: '#666666', // Lighter grey menu text
      colorTextMenuSecondary: '#999999', // Even lighter grey secondary menu text
      colorTextMenuTitle: '#333333', // Dark grey menu title text
      colorTextSubMenuSelected: '#333333', // Dark grey submenu selected text
      colorBgMenuItemActive: '#E6E6E6', // Light grey menu item active background
      colorBgMenuItemCollapsedElevated: 'transparent',
    },
    header: {
      colorBgHeader: '#F8F8F8', // Light grey header background
      colorBgScrollHeader: '#F0F0F0', // Slightly darker light grey scroll header background
      colorHeaderTitle: '#333333', // Dark grey header title text
      colorBgMenuItemHover: '#E6E6E6', // Light grey menu item hover background
      colorBgMenuItemSelected: 'transparent',
      colorTextMenuSelected: '#333333', // Dark grey menu selected text
      colorBgRightActionsItemHover: '#F0F0F0', // Light grey right actions item hover background
      colorTextRightActionsItem: '#666666', // Lighter grey right actions item text
      heightLayoutHeader: 56,
      colorTextMenu: '#666666', // Lighter grey menu text
      colorTextMenuSecondary: '#999999', // Even lighter grey secondary menu text
      colorTextMenuActive: '#333333', // Dark grey menu active text
      colorBgMenuElevated: '#F8F8F8', // Light grey elevated menu background
    },
    pageContainer: {
      colorBgPageContainer: 'transparent',
      paddingInlinePageContainerContent: 40,
      paddingBlockPageContainerContent: 32,
      colorBgPageContainerFixed: '#FFFFFF', // White fixed page container background
    },
  },
};
